import { render } from "./Patient.vue?vue&type=template&id=2638822f&scoped=true"
import script from "./Patient.vue?vue&type=script&lang=js"
export * from "./Patient.vue?vue&type=script&lang=js"

import "./Patient.vue?vue&type=style&index=0&id=2638822f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2638822f"

export default script